import { Directive } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

@Directive({
    selector: '[appInputTrimmer]',
})
export class InputTrimmerDirective {
    constructor(private ngControl: NgControl) {
        trimValueAccessor(ngControl.valueAccessor);
    }
}

export const trimValueAccessor = (valueAccessor: ControlValueAccessor): any => {
    const original: any = valueAccessor.registerOnChange;
    valueAccessor.registerOnChange = (fn: (_: unknown) => void) =>
        original.call(valueAccessor, (value: unknown) => fn(typeof value === 'string' ? value.trim() : value));
};
